// extracted by mini-css-extract-plugin
module.exports = {"chart":"NetworkDemographics_chart__31Yh-"};